"use strict";
function pagination(){
    document.querySelectorAll(".loadMoreAct").forEach((btn) => {
      btn.classList.remove('loading');
      var url = btn.getAttribute('href');
      if (btn.classList.contains("infinite")){
        var observer = new IntersectionObserver(
          function(entries){
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1){
                loadMoreproducts(url);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(btn);
      } else {
        btn.addEventListener("click",(e) => {
            e.preventDefault();
            btn.classList.add('loading');
            loadMoreproducts(url);
          },
          false
        );
      }
    });
}
pagination();
function loadMoreproducts(url){
    fetch(url).then((response) => response.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html'),
        products = document.getElementById('collectionPr'),
        productsSource = html.querySelector('#collectionPr').innerHTML,
        pagination = document.getElementById('pagination'),
        paginationSource = html.querySelector('#pagination');

      if(products) products.insertAdjacentHTML('beforeend', productsSource);
      if(pagination && paginationSource) {
        pagination.innerHTML = paginationSource.innerHTML;
      } else {
        pagination.innerHTML = '';
      }
    })
    .finally(() => {
      pagination();
      if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
      initializeVideos();
      initializeScrollAnimationTrigger();
      // UAH→EUR converter disabled
      document.dispatchEvent(new CustomEvent('price:change'));
    })
    .catch((e) => {
      console.error(e);
    });
}

class FiltersForm extends HTMLElement {
  constructor() {
      super();
      this.secId = this.dataset.id;
      this.mql = window.matchMedia('(min-width: 767px)');
  }
  connectedCallback() {
      var fbtns = document.querySelectorAll(".btn-filter");
      fbtns.forEach((btn) =>
        btn.addEventListener('click', this.mobileFilters.bind(this))
      );
      if (this.mql.matches) this.blockToggle();
      this.selectFilters();
      this.priceRangeSlider();
      this.removeFilters();
      this.selectSort();
  }
  isTopFilterMode(){
    return !!this.closest('.flTop');
  }
  selectSort(){
    var shortby = document.getElementById('SortBy');
    shortby.addEventListener('change', this.onFormSubmit.bind(this));
  }
  selectFilters(){
    var filters = this.querySelectorAll('input');
    filters.forEach((filter) =>
       filter.addEventListener('change', this.onFormSubmit.bind(this))
    );
  }
  priceRangeSlider(){
    const isPriceRange = document.getElementById('priceSlider');
    if(!isPriceRange) return;
    const priceSlider = document.getElementById('priceSlider'),
      min = document.getElementById('Filter-Price-GTE'),
      max = document.getElementById('Filter-Price-LTE');

    priceSlider.addEventListener('change', (evt) => {
        min.value = evt.detail.value1.toString();
        max.value = evt.detail.value2.toString();
    });
    priceSlider.addEventListener('onMouseUp', (evt) => {
      min.dispatchEvent(new Event("change"));
      max.dispatchEvent(new Event("change"));
    });
    priceSlider.addEventListener('touchend', (evt) => {
      min.dispatchEvent(new Event("change"));
      max.dispatchEvent(new Event("change"));
    });
  }
  onFormSubmit(e){
    const flForm = this.querySelector('form'),
      formData = new FormData(flForm),
      params = new URLSearchParams(formData),
      singleOpenMode = this.isTopFilterMode() && window.innerWidth > 1024,
      activeFilter = e && e.target ? e.target.closest('.filterBx') : null,
      activeFilterIndex = activeFilter ? activeFilter.dataset.index : null,
      filterWrap = this.querySelector('.filterWrap'),
      openedFilterIndices = Array.from(this.querySelectorAll('.filterBx[open]'))
        .map((item) => item.dataset.index)
        .filter(Boolean),
      filterWrapScrollTop = filterWrap ? filterWrap.scrollTop : 0;

      this.renderSectionFromFetch(params, {
        singleOpenMode,
        activeFilterIndex,
        openedFilterIndices,
        filterWrapScrollTop
      });
  }
  applyCurrentFiltersAndClose(){
    const flForm = this.querySelector('form');
    if (!flForm) return Promise.resolve();
    const formData = new FormData(flForm),
      params = new URLSearchParams(formData),
      filterWrap = this.querySelector('.filterWrap'),
      filterWrapScrollTop = filterWrap ? filterWrap.scrollTop : 0;
    return this.renderSectionFromFetch(params, {
      openedFilterIndices: [],
      filterWrapScrollTop
    });
  }
  renderSectionFromFetch(params, options = {}){
    const url = `${window.location.pathname}?section_id=${this.secId}&${params.toString()}`
    return fetch(url).then((response) => response.text()).then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html'),
          products = document.getElementById('collectionPr'),
          filters = this.querySelector('.filterWrap'),
          counts = document.getElementById('itemsCount'),
          pagination = document.getElementById('pagination'),
          paginationSource =  html.querySelector('#pagination'),
          activeFilters =  document.getElementById('activeFilters');

        if(counts) counts.innerHTML = html.querySelector('#itemsCount').innerHTML;
        if(activeFilters) activeFilters.innerHTML = html.querySelector('#activeFilters').innerHTML;
        if(products) products.innerHTML = html.querySelector('#collectionPr').innerHTML;
        if(filters) {
          filters.innerHTML = html.querySelector('.filterWrap').innerHTML;

          // Keep filter panels open after AJAX update.
          if (options.singleOpenMode) {
            const preferredIndex = options.activeFilterIndex ||
              (Array.isArray(options.openedFilterIndices) ? options.openedFilterIndices[0] : null);
            if (preferredIndex) {
              const onlyFilterToOpen = filters.querySelector(`.filterBx[data-index="${preferredIndex}"]`);
              if (onlyFilterToOpen) onlyFilterToOpen.setAttribute('open', '');
            }
          } else if (Array.isArray(options.openedFilterIndices)) {
            options.openedFilterIndices.forEach((index) => {
              const filterToOpen = filters.querySelector(`.filterBx[data-index="${index}"]`);
              if (filterToOpen) filterToOpen.setAttribute('open', '');
            });
          }

          if (!options.singleOpenMode && options.activeFilterIndex) {
            const activeFilterToOpen = filters.querySelector(`.filterBx[data-index="${options.activeFilterIndex}"]`);
            if (activeFilterToOpen) activeFilterToOpen.setAttribute('open', '');
          }

          if (typeof options.filterWrapScrollTop === 'number') {
            filters.scrollTop = options.filterWrapScrollTop;
          }
        }
        if(pagination && paginationSource) {
          pagination.innerHTML = paginationSource.innerHTML;
        } else if(pagination) {
          pagination.innerHTML = ' ';
        }
      })
      .finally(() => {
        const url = `${window.location.pathname}?${params.toString()}`
        history.pushState({ page: url }, url, url);
        this.selectFilters();this.priceRangeSlider();this.removeFilters();this.blockToggle();pagination();
        if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
        initializeVideos();
        initializeScrollAnimationTrigger();
        // UAH→EUR converter disabled
        document.dispatchEvent(new CustomEvent('price:change'));
      })
      .catch((e) => {
        console.error(e);
      });
  }
  removeFilters(){
    var _this = this,
        activeFl = document.querySelectorAll(".active-fl");
    activeFl.forEach((btn) => {
        btn.addEventListener("click",(e) => {
          e.preventDefault();
          var params = btn.getAttribute('href').split('?')[1];
          _this.renderSectionFromFetch(params);
        })
      });
  }
  mobileFilters(){
    var html = document.documentElement;
    html.classList.add('activFilter','showOverly');
    var overlay = document.querySelector('.modalOverly');
    if (overlay) overlay.style.display = 'block';
    const blocks = this.querySelectorAll('.filterBx');
    blocks.forEach((blk) => {
      blk.open = true;
    });
    var filterWrap = this.querySelector('.filterWrap');
    if (filterWrap && window.innerWidth <= 1024) {
      requestAnimationFrame(function(){
        filterWrap.style.width = filterWrap.offsetWidth + 'px';
        filterWrap.style.boxSizing = 'border-box';
      });
    }
    var closeBtn = document.querySelector(".closeFilter");
    function closePanel(){
      html.classList.remove('activFilter','showOverly');
      if (overlay) overlay.style.display = 'none';
      if (filterWrap) { filterWrap.style.width = ''; filterWrap.style.boxSizing = ''; }
      closeBtn.removeEventListener('click', closePanel);
    }
    closeBtn.addEventListener('click', closePanel);
  }
  blockToggle(){
      if (!this.isTopFilterMode()) return;

      const blocks = this.querySelectorAll('.filterBx');
      blocks.forEach((blk) => {
        if (blk.dataset.singleOpenBound === 'true') return;
        blk.addEventListener('toggle', () => {
          if (!blk.open) return;
          if (window.innerWidth <= 1024) return;
          this.querySelectorAll('.filterBx[open]').forEach((other) => {
            if (other !== blk) other.removeAttribute('open');
          });
        });
        blk.dataset.singleOpenBound = 'true';
      });

      if (this._boundOutsideClick) {
        document.body.removeEventListener('click', this._boundOutsideClick);
      }

      this._boundOutsideClick = (e) => {
        if (window.innerWidth <= 1024) return;
        if (e.target.closest('.flTop .filterBx[open]')) return;
        if (!this.querySelector('.filterBx[open]')) return;
        this.querySelectorAll('.filterBx[open]').forEach((blk) => blk.removeAttribute('open'));
      };

      document.body.addEventListener('click', this._boundOutsideClick);
  }
}
customElements.define("filters-form", FiltersForm);

document.querySelectorAll(".change-view").forEach((btn) => {
  btn.addEventListener("click",(e) => {
     e.preventDefault();
      var view = btn.dataset.view,
        href = new URL(window.location.href);
      href.searchParams.set("type", view);
      window.location = href.toString();
  });
});